<div class="content-wrapper container-xxl p-0">
    <div class="content-body card xplorer-payment">
        <div class="card mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-12">

                            <form #paymentDetails="ngForm">
                                <!-- <payment (childCallbackSender)="parentCallbackFormChild($event)"></payment> -->
                                <!-- <add-bank-account-for-remittance *ngIf="showAddBankForm" (childCallbackForAddBankAccountForm)="parentCallbackForAddBankAccountForm($event)">
                                </add-bank-account-for-remittance> -->

                                <section *ngIf="!showAddBankForm">

                                    <div class="d-flex align-items-stretch">

                                    <!-- <div class="row mt-30"> -->

                                        <!-- <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12 col-xs-12"> -->
                                        <div class="currency-panel pl-0">
                                            <div class="inner-input-field-wrapper">

                                            <div class="row mb-20">
                                                <div class="col-md-12  mb-10">
                                                    <h6 class="content-header-title float-left mb-0">
                                                        Payment
                                                    </h6>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="fs-11">Complete your payment successfully to proceed with your Card request.</div>
                                                </div>
                                            </div>

                                            <loader *ngIf="showLoader"></loader>

                                            <!-- <section class="referrer-section mt-20" *ngIf="!referredStatus">
                                                <div class="row">
                                                    <div class="col-md-9 col-9">
                                                        <div class="form-group">
                                                            <label class="form-group m-form__group mb-0">Apply Referral Code</label>
                                                            <input type="text" name="referralCode" [(ngModel)]="referralCode" class="form-control fs-12" placeholder="Enter referral Code*" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-3 pl-0 d-flex align-items-end">
                                                        <div class="form-group">
                                                            <button class="btn btn-primary" (click)="applyReferralCode()">Apply</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section> -->

                                            <!-- <section class="offer-section mt-20">
                                                <div class="row">
                                                    <div class="col-md-9 col-9">
                                                        <div class="form-group m-form__group">
                                                            <label class="form-group m-form__group mb-0">Apply Coupon</label>
                                                    <ng-select #refPromoCodeList name="offer" [items]="listOffers" bindLabel="title" bindValue="promoCodeId" [addTag]="addNewCoupon" addTagText="Add New Coupon" [(ngModel)]="promoCode" placeholder="" class="fs-12"  placeholder="Select Coupon or add Coupon" required>
                                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                                            <b>{{item.title}}</b><br>
                                                            <span>{{item.shortDescription}}</span>
                                                        </ng-template>
                                                    </ng-select>

                                                        </div>
                                                    </div>

                                                    <div class="col-md-2 col-3 pl-0 mt-23" *ngIf="!promoCodeApplied">
                                                        <button class="btn btn-primary" (click)="applyPromoCode()">Apply</button>
                                                    </div>

                                                    <div class="col-md-2 col-3 pl-0 mt-23" *ngIf="promoCodeApplied">
                                                        <button class="btn btn-danger" (click)="removePromoCode()">Remove</button>
                                                    </div>
                                                </div>
                                            </section> -->

                                            <!-- <section class="col-md-12 redeempoints-section mt-20  redeem-points p-15">
                                                <div class="row">
                                                    <div class="col-md-9 col-9">
                                                        <div class="form-group">
                                                            <input type="text" class="form-control fs-12" name="pointsToRedeem" placeholder="Enter Redeemable Points*" [(ngModel)]="pointsToRedeem" oninput="this.value = 
                                                    !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null" pattern="^[1-9][0-9]*$" required oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-3 pl-0 " *ngIf="!creditPointApplied">
                                                        <button class="btn btn-primary" (click)="applyCreditPointToQuote()">Apply</button>
                                                    </div>
                                                    <div class="col-md-3 col-3 pl-0" *ngIf="creditPointApplied">
                                                        <button class="btn btn-danger" (click)="removeCreditPoint()">Remove</button>
                                                    </div>
                                                    <div class="col-md-12 d-flex justify-content-between align-items-center mt-2">
                                                        <div class="text-black fw-500 fs-10">You have {{ redeemableCredits?.availableCredit }} points</div>
                                                        <div class="text-black fw-500 fs-10 text-right">1 point = ₹ {{ redeemableCredits?.costPerCredit }}</div>
                                                    </div>
                                                </div>
                                            </section> -->


                                            <div class="col-md-12 mb-30 mt-30 pl-0 d-flex align-items-center">
                                                <div class="col-md-6 col-sm-6 pl-0 d-flex justify-content-start align-items-center">
                                                    <div class="fs-12 text-black pl-0 fw-600">
                                                        Choose Your Bank Account
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6 d-flex justify-content-end   mt-md-0">
                                                    <button type="button" class="btn btn-primary btn-prev fs-12" rippleeffect="" (click)="openModalForAddBankAccount(addBankAccountModal)" style="
                                                font-size: 13px !important;">Add Bank Account</button>

                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12 mb-20" *ngFor="let singleBank of bankAccountList; let i=index">
                                                    <div [ngClass]="(bankAccountList.length - 1) == i ? 'border-bottom-white' : 'border-bottom-grey' ">
                                                        <div class="row mb-10">
                                                            <!-- <div class="col-md-1 col-1">
                                                </div> -->
                                                            <div class="col-md-12 col-11">
                                                                <input type="radio" name="radios" id="radio" (change)="getSelectedBankAccountID(singleBank.id)" />

                                                                <span class="card-title fs-12 text-black fw-600 mb-10" style="margin-left:10px">
                                                            {{ singleBank.bankName }}
                                                        </span>
                                                                <div class="fs-11  ml-25"> Account No : {{singleBank.number}}</div>
                                                                <div class="fs-11  ml-25"> IFSC Code : {{singleBank.ifscCode}}</div>
                                                                <div class="fs-11  ml-25"> Branch : {{singleBank.branch}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="row mt-20">
                                                <div class="col-md-12">
                                                    <div class="fs-12 text-black fw-600">
                                                        Payment Type
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mt-3 mb-1 align-items-center">
                                                <div class="col-8 col-md-6 fs-6">
                                                    <input type="radio" name="paymentType" id="radio" value='false' [(ngModel)]="isPartial" (click)="getSelectedPaymentType(false)" /> &nbsp; &nbsp; Full Payment
                                                </div>
                                                <div class="col-4 col-md-4 fw-bold">
                                                    ₹ {{this.xplorerCardQuote?.totalAmount}}
                                                </div>
                                            </div>

                                            <div class="row  mt-30">
                                                <div class="col-md-12">
                                                    <div class="fs-12 text-black fw-600 mb-20">
                                                        Payment Method
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mb-20">
                                                <!-- <div class="col-md-4 fs-12 mb-20" *ngIf="showNetBanking || !showNEFT">
                                                    <input type="radio" name="paymentRadio" id="radio" value='NB' (click)="getSelectedPaymentMode('NB')" /> &nbsp; &nbsp; Net Banking
                                                </div>
                                                <div class="col-md-4 fs-12 mb-20" *ngIf="ALLOW_NEFT_PAYMENT && showNEFT">
                                                    <input type="radio" name="paymentRadio" id="radio" value='MANUAL' (click)="getSelectedPaymentMode('MANUAL')" /> &nbsp; &nbsp; NEFT/RTGS/IMPS
                                                </div> -->
                                                <div class="col-md-4 fs-12 mb-20" *ngIf="ALLOW_UPI_PAYMENT">
                                                    <input type="radio" name="paymentRadio" id="radio" value='UPI' [(ngModel)]="paymentMode" (click)="getSelectedPaymentMode('UPI')" /> &nbsp; &nbsp; UPI
                                                </div>

                                            </div>

                                            <div *ngIf="selectedPaymentMode == 'MANUAL'">
                                                <div class="mt-20">
                                                    <div class="fs-12 fw-600  text-black">{{ accountName }}</div>
                                                    <div class="fs-11  text-black">{{ bankName }}</div>
                                                    <div class="fs-11  text-black">{{ accountNo }}</div>
                                                    <div class="fs-11  text-black">{{ bankIFSC }}</div>
                                                    <div class="fs-11  text-black">{{ bankBranch }}</div>
                                                </div>

                                                <div class="mb-30 fs-10 text-danger mt-30  text-500">
                                                    Note: Please send an NEFT/RTGS/IMPS payment towards your order to the above account. The payment is to be transferred within 8 hours of order completion and the reference details of the transfer is to be updated in the My Order section.
                                                </div>
                                            </div>
                                                    <div class="row mb-20" *ngIf="showCashRefundNote">
                                                        <div class="col-md-12 fs-12 mb-20 text-500" >
                                                            Note: If the currency is not available at the requested branch the amount
                                                            paid will be refunded in 5 working days
                                                        </div>
                        
                                                    
                                                    </div>
                                            </div>
                                        </div>

        
                                        <div class="vr-divider"></div>
        
                                        <!-- <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12 col-xs-12"> -->
                                        <div class="currency-panel pr-0">
                                            <!-- <div class="currency-panel-box mt-2"> -->
                                                <div class="xplorer-breakup-wrapper">
                                                    <div class="table-responsive amout-breakup-bg">
                                                        <table class="table table-condensed table-borderless  fs-12" aria-label="Xplorer Card Details">
                                                            <caption class="visually-hidden">Xplorer Card Details</caption>
                                                            <thead>
                                                                <tr>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr style="background-color: #E8E8E8;">
                                                                    <td class="thick-line text-black fw-600" colspan="4">
                                                                        <div class="d-flex flex-row">
                                                                            <div class="breakup-forex-icon"><img src="assets/images/icon/Card details.png" alt="" /></div><span>Xplorer Card Details</span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="no-line " colspan="3"><strong>Kit Fee : </strong></td>
                                                                    <td class="no-line text-right">₹ {{ xplorerCardQuote?.kitFee }} </td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="no-line " colspan="3"><strong>GST</strong></td>
                                                                    <td class="no-line text-right">₹ {{ xplorerCardQuote?.gst }} </td>
                                                                </tr>
                                                                <tr style="border-top:1px solid #EBEBEB; background:#E8E8E8;">
                                                                    <td class="no-line text-black fw-800 pt-10" colspan="3"> Total: </td>
                                                                    <td class="no-line text-right text-black fw-800 pt-10"> ₹ {{ xplorerCardQuote?.totalAmount }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            <!-- </div> -->
                                        </div>

                                    <!-- </div> -->
                                    </div>

                                </section>


                                <!-- <div class="d-flex justify-content-between">
                                    <button (click)="horizontalWizardStepperPrevious()" class="btn btn-primary btn-next fs-12" rippleEffect>
                                    <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                    <span class="align-middle">Back</span>
                                </button>
                                    <button class="btn btn-primary btn-gradient  fs-12 forex-card-order" rippleEffect (click)="openModalForPaymentInfo(travelDocumentInstructionModal, bookAndPayInstructionModal)" [ngClass]="{ 'web-card-order-payment' : cartType == 'CARD_PURCHASE', 'web-reload-order-payment': cartType == 'CARD_RELOAD',  'web-currency-buy-order-payment' : cartType == 'CASH_PURCHASE' }">Proceed</button>
                                </div> -->
                            </form>


                                <div class="d-flex justify-content-between">
                                    <button class="btn btn-primary btn-gradient  fs-12 forex-card-order" rippleEffect (click)="goToBackXplorerCard()" >Back</button>
                                    <button class="btn btn-primary btn-gradient  fs-12 forex-card-order" rippleEffect (click)="getPayULink()" >Proceed</button>
                                </div>

                </div>
              </div>
            </div>
        </div>
    </div>
</div>
<ng-template let-modal #addBankAccountModal>
    <div class="modal-header">
        <h6 class="modal-title" id="myModalLabel1"></h6>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <form class="form-horizontal" autocomplete="xxvv67_ghfhg" (ngSubmit)="addBankAccount(AddBankAccount.form.valid)" #AddBankAccount="ngForm">
            <div class="col-md-12">
                <loader *ngIf="showLoader"></loader>
                <div class="row mt-15">
                    <div class="form-group col-md-6">
                        <label class="form-label">Name</label>
                        <input required type="text" class="form-control fs-12" placeholder="Name" [(ngModel)]="addBankAccountRequest.nameAsPerAccountNumber" name="name" autocomplete="new_name" #nameRef="ngModel" [class.error]="AddBankAccount.submitted && nameRef.invalid" (keypress)="alphaNumberOnly($event)"
                            (paste)="onPaste($event)" maxlength="100" required />
                        <span *ngIf="AddBankAccount.submitted && nameRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="nameRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="form-label" for="country">Relationship*</label>
                        <ng-select class="fs-12" [items]="bankRelationshipList" bindValue="bankRelationshipList" [(ngModel)]="addBankAccountRequest.relation" required placeholder="Relationship" name="relationship" #relationshipRef="ngModel" [class.error]="AddBankAccount.submitted && relationshipRef.invalid"
                            [clearable]="false" [searchable]="true">
                        </ng-select>
                        <span *ngIf="AddBankAccount.submitted && relationshipRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="relationshipRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                </div>
                <div class="row mt-15">
                    <div class="form-group col-md-6">
                        <label class="form-label" for="country">Bank Name*</label>
                        <ng-select [items]="bankDropdownItemList" bindLabel="displayName" bindValue="displayName" [(ngModel)]="addBankAccountRequest.bankName" placeholder="Select" name="bank_name" #bankNameRef="ngModel" [class.error]="AddBankAccount.submitted && bankNameRef.invalid"
                            [searchable]="false" required>
                        </ng-select>
                        <span *ngIf="AddBankAccount.submitted && bankNameRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="bankNameRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="form-label">Branch Name</label>
                        <input type="text" class="form-control fs-12" autocomplete="ytt86_fdhdh_00dty"  name="branch_name" placeholder="Branch Name" maxlength="100" [(ngModel)]="bankBranchName" #branchNameRef="ngModel" [class.error]="AddBankAccount.submitted && branchNameRef.invalid" required />
                        <span *ngIf="AddBankAccount.submitted && branchNameRef.invalid" class="invalid-form">
                            <small class="text-danger" *ngIf="branchNameRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                </div>
                <div class="row mt-15">
                    <div class="form-group col-md-6">
                        <label class="form-label">Account Number</label>
                        <div class="input-group form-password-toggle">
                            <input [type]="showAccountNo ? 'text' : 'password'" class="form-control fs-12" [(ngModel)]="addBankAccountRequest.number" placeholder="Account Number" name="account_no" #accountNoRef="ngModel" [class.error]="AddBankAccount.submitted && accountNoRef.invalid"
                                (keypress)="keyPressNumbers($event)" (paste)="onPaste($event)" maxlength="30" required  autocomplete="fht_dhhj_jkjk" />
                            <div class="input-group-append" (click)="showAccountNo = !showAccountNo">
                                <span class="input-group-text cursor-pointer" style="height:38px !important"><i class="feather"
                                [ngClass]="{'icon-eye-solid': showAccountNo, 'icon-eye-slash-solid': !showAccountNo }"></i></span>
                            </div>

                        </div>
                        <!-- <input required type="password" class="form-control fs-12" placeholder="Account Number" [(ngModel)]="addBankAccountRequest.number" name="account_no" #accountNoRef="ngModel" [class.error]="AddBankAccount.submitted && accountNoRef.invalid" required /> -->
                        <span *ngIf="AddBankAccount.submitted && accountNoRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="accountNoRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="form-label">Confirm Account Number</label>
                        <input required type="text" name="confirm_acccount_no" class="form-control fs-12" placeholder="Confirm Account Number" [(ngModel)]="addBankAccountRequest.confirmAccNo" #confirmAccountNoRef="ngModel" [class.error]="AddBankAccount.submitted && confirmAccountNoRef.invalid"
                            (keypress)="keyPressNumbers($event)" (paste)="onPaste($event)" maxlength="30" required autocomplete="new_confimaccountno" />
                        <span *ngIf="AddBankAccount.submitted && confirmAccountNoRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="confirmAccountNoRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                </div>

                <div class="row mt-15">

                    <div class="form-group col-md-6">
                        <label class="form-label">IFSC Number</label>
                        <input type="text" class="form-control fs-12" name="ifscCode" autocomplete="new_ifsc" placeholder="IFSC Number" [(ngModel)]="addBankAccountRequest.ifscCode" #ifscCodeRef="ngModel" [class.error]="AddBankAccount.submitted && ifscCodeRef.invalid" required pattern="([A-Za-z0]{4})(0\d{6})$"
                            (keypress)="alphaNumberOnly($event)" (paste)="onPaste($event)" maxlength="11" />
                        <span *ngIf="AddBankAccount.submitted && ifscCodeRef.invalid" class="invalid-form">
                            <small class="text-danger" *ngIf="ifscCodeRef.errors.required">This field is required!</small>
                        </span>
                        <div class="text-danger fs-11" *ngIf="AddBankAccount.submitted && ifscCodeRef.invalid">IFSCCode must be in valid format!</div>
                    </div>
                </div>

                <div class="row">
                    <button class="col-md-2 offset-md-5 btn btn-primary fw-500 fs-12 text-center blue-text" type="submit" style="cursor: pointer;">
                        Add
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>